import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AnimatedSection } from '../components/AnimatedSection';
import { CardGrid, CardProps } from '../components/CardGrid';
import { PlaceholderGraphic } from '../components/PlaceholderGraphic';
export interface PageModule {
  title: string;
  subtitle?: string;
  type: 'cards' | 'text' | 'logos' | 'custom';
  cards?: CardProps[];
  content?: React.ReactNode;
  proof_chips?: string[];
  graphic?: string;
}
export interface GenericPageProps {
  hero: {
    eyebrow?: string;
    headline: string;
    subhead: string;
    primaryCta?: {
      label: string;
      to: string;
    };
    secondaryCta?: {
      label: string;
      to: string;
    };
    graphic?: React.ReactNode;
  };
  modules: PageModule[];
}
export function GenericPage({
  hero,
  modules
}: GenericPageProps) {
  return <div className="pb-20" data-id="element-346">
      <HeroSection {...hero} data-id="element-347" />

      <div className="max-w-7xl mx-auto px-6 space-y-32 mt-12" data-id="element-348">
        {modules.map((mod, idx) => <section key={idx} data-id="element-349">
            <AnimatedSection data-id="element-350">
              <h2 className="text-3xl md:text-4xl font-serif mb-4 text-white" data-id="element-351">
                {mod.title}
              </h2>
              {mod.subtitle && <p className="text-picus-muted text-lg mb-12 max-w-3xl" data-id="element-352">
                  {mod.subtitle}
                </p>}
            </AnimatedSection>

            {mod.type === 'cards' && mod.cards && <CardGrid cards={mod.cards} columns={mod.cards.length % 4 === 0 ? 4 : 3} data-id="element-353" />}

            {mod.type === 'custom' && mod.content && <AnimatedSection delay={0.2} data-id="element-354">{mod.content}</AnimatedSection>}

            {mod.graphic && <AnimatedSection delay={0.2} className="mt-8" data-id="element-355">
                <PlaceholderGraphic description={mod.graphic} data-id="element-356" />
              </AnimatedSection>}

            {mod.proof_chips && <AnimatedSection delay={0.3} className="flex flex-wrap gap-3 mt-8" data-id="element-357">
                {mod.proof_chips.map((chip, i) => <span key={i} className="border border-picus-border rounded-full px-4 py-1.5 text-sm text-picus-muted" data-id="element-358">
                    {chip}
                  </span>)}
              </AnimatedSection>}

            {mod.type === 'logos' && <AnimatedSection delay={0.2} className="flex flex-wrap gap-8 items-center opacity-50 grayscale" data-id="element-359">
                {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="h-12 w-32 bg-picus-surface border border-picus-border rounded flex items-center justify-center text-xs text-picus-muted" data-id="element-360">
                    LOGO {i}
                  </div>)}
              </AnimatedSection>}
          </section>)}
      </div>
    </div>;
}